export const CATEGORY_ICONS = {
  film: 'film',
  series: 'series',
  game: 'game',
  music: 'music',
  book: 'book',
};

export const CATEGORY_CONFIG = {
  film: { iconName: 'film', color: '#757575', nameRu: 'Фильм' },
  series: { iconName: 'series', color: '#757575', nameRu: 'Сериал' },
  game: { iconName: 'game', color: '#757575', nameRu: 'Игра' },
  music: { iconName: 'music', color: '#757575', nameRu: 'Музыка' },
  book: { iconName: 'book', color: '#757575', nameRu: 'Книга' },
};

export const DEFAULT_CATEGORY = {
  iconName: null,
  color: '#757575',
  nameRu: 'Медиапроект',
};

export const ACTIVITY_TYPES = {
  added_to_shelf: 'добавил(а) на полку',
  added_to_wishlist: 'добавил(а) в вишлист',
  rated: 'оценил(а) на',
  commented: 'оставил(а) комментарий',
  default: 'поделился(ась)',
};

export const PLACEHOLDER_IMAGE =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='400'%3E%3Crect width='100%25' height='100%25' fill='%2323292f'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' fill='%23ffffff' font-size='22' font-family='Arial, sans-serif'%3E%3C/text%3E%3C/svg%3E";